import "@/App.css";
import { LanguageProvider } from './context/LanguageContext';
import { Navbar } from './components/landing/Navbar';
import { Hero } from './components/landing/Hero';
import { BeforeAfterSlider } from './components/landing/BeforeAfterSlider';
import { IPhoneVideoSlider } from './components/landing/IPhoneVideoSlider';
import { BentoFeatures } from './components/landing/BentoFeatures';
import { HowItWorks } from './components/landing/HowItWorks';
import { Pricing } from './components/landing/Pricing';
import { Testimonials } from './components/landing/Testimonials';
import { FAQ } from './components/landing/FAQ';
import { Footer } from './components/landing/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#0d0a07] text-white overflow-x-hidden">
        <Navbar />
        <main>
          <Hero />
          <BeforeAfterSlider />
          <IPhoneVideoSlider />
          <Pricing />
          <BentoFeatures />
          <HowItWorks />
          <Testimonials />
          <FAQ />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
